import { baseApi as api } from 'shared/api/baseApi';

import { IExtra } from '../model/types';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		notificationsList: build.query<NotificationsListApiResponse, NotificationsListApiArg>({
			query: (queryArg) => ({
				url: `/api/notifications/`,
				params: {
					category: queryArg.category,
					created_after: queryArg.createdAfter,
					created_before: queryArg.createdBefore,
					limit: queryArg.limit,
					offer_id: queryArg.offerId,
					offset: queryArg.offset,
					read: queryArg.read,
					source_id: queryArg.sourceId,
				},
			}),
		}),
		notificationsMarkAsReadCreate: build.mutation<
			NotificationsMarkAsReadCreateApiResponse,
			NotificationsMarkAsReadCreateApiArg
		>({
			query: (queryArg) => ({ url: `/api/notifications/mark_as_read`, method: 'POST', body: queryArg }),
		}),
		notificationsUnreadCountRetrieve: build.query<
			NotificationsUnreadCountRetrieveApiResponse,
			NotificationsUnreadCountRetrieveApiArg
		>({
			query: () => ({ url: `/api/notifications/unread_count` }),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type NotificationsListApiResponse = /** status 200  */ PaginatedNotificationList;
export type NotificationsListApiArg = {
	category?: string;
	createdAfter?: string;
	createdBefore?: string;
	/** Number of results to return per page. */
	limit?: number;
	offerId?: string[];
	/** The initial index from which to return the results. */
	offset?: number;
	read?: boolean;
	sourceId?: (string | null)[];
};
export type NotificationsMarkAsReadCreateApiResponse = /** status 200  */ PrimaryKeys;
export type NotificationsMarkAsReadCreateApiArg = PrimaryKeys;
export type NotificationsUnreadCountRetrieveApiResponse = /** status 200  */ NotificationUnreadCount;
export type NotificationsUnreadCountRetrieveApiArg = void;
export type NotificationOffer = {
	id: string;
	name: string;
	slug: string;
};
export type NotificationSource = {
	id: string;
	name: string;
};
export type Notification = {
	id: number;
	created_at: string;
	user_id: string;
	offer: NotificationOffer;
	source: NotificationSource;
	type: string;
	category: string;
	alert: boolean;
	read: boolean;
	icon: string;
	extra: IExtra; //TODO: manual type
};
export type PaginatedNotificationList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: Notification[];
};
export type PrimaryKeys = {
	ids: number[];
};
export type NotificationUnreadCount = {
	unread_count: number;
};
